import { createSchemaSelectors } from 'ngrx-normalizr';
import { Symptoms, symptomsSchema } from '../schemas/symptoms.schema';

const symptomsSelectorsSchema = createSchemaSelectors<Symptoms>(symptomsSchema);

export const getSymptoms = symptomsSelectorsSchema.getEntities;
